<template>
  <div class="app-paginate-view">
    <div class="app-paginate-view__show">Показывать по:</div>
    <div
      v-for="btn in btns"
      :key="btn.value"
      class="app-paginate-view__link"
      :class="{ 'app-paginate-view__link-active': btn.isActive }"
      @click="setPageSize(btn.value)"
    >
      {{ btn.text }}
    </div>
  </div>
</template>

<script>
import { rootMapper } from '@/store/root';

export default {
  name: 'AppPaginateView',
  props: {
    selectedPageSize: {
      type: Number,
      default: 20,
    },
  },
  data: () => ({
    btns: [
      { text: '20', value: 20, isActive: false },
      { text: '50', value: 50, isActive: false },
      { text: '100', value: 100, isActive: false },
    ],
  }),
  created() {
    this.btns.forEach((el) => {
      if (el.value === this.selectedPageSize) {
        // eslint-disable-next-line no-param-reassign
        el.isActive = true;
        this.setPageSizeToStore(this.selectedPageSize);
      }
    });
  },
  methods: {
    ...rootMapper.mapMutations(['SET_PAGE_SIZE']),
    /**
     * Установка кол-ва элементов на странице
     * @param value
     */
    setPageSize(value) {
      this.btns.forEach((el) => {
        if (el.value === value) {
          // eslint-disable-next-line no-param-reassign
          el.isActive = true;
          this.$emit('changingPageSize', value);
          this.setPageSizeToStore(value);
        } else {
          // eslint-disable-next-line no-param-reassign
          el.isActive = false;
        }
      });
    },
    /**
     * Записываем в store кол-во элементов
     * @param {Number} - кол-во элементов
     */
    setPageSizeToStore(value) {
      const pageSizeItem = {
        routeName: this.$route.name,
        value,
      };

      this.SET_PAGE_SIZE(pageSizeItem);
    },
  },
};
</script>

<style lang="scss">
.app-paginate-view {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 48px;
  padding: 0 15px;
  line-height: 48px;
  background: #fff;
  border-radius: 38px;
  box-shadow: 0 4px 10px rgba(221, 222, 222, 0.5);

  @include media-xxs() {
    display: none;
  }

  &__show {
    padding: 0 10px;
    font-size: rem(14);
    color: #202020;

    @include media-md() {
      padding: 0 10px;
      font-size: rem(12);
    }
  }

  &__link {
    padding: 0 15px;
    font-size: rem(14);
    color: #202020;
    cursor: pointer;
    transition: all $A;

    @include media-md() {
      padding: 0 10px;
      font-size: rem(12);
    }

    &:hover {
      color: #fff;
      background: $color-brand-green;
    }
  }

  &__link-active {
    background: #d5ffe9;
  }
}
</style>
